import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, withStyles} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PageTitle from "../../../components/PageTitle/PageTitle";
import {pageConfiguracoes} from "../../../utils/getPageTitle";
import HeaderConfiguracoesButtonNovo from "../Components/HeaderConfiguracoesButtonNovo";
import Table from "../../../components/Table/Table";
import Notification from "../../../components/Notification";
import MensagemListaVazia from "../../../components/Mensagem/MensagemListaVazia";
import {
  atualizarRegistroHoraProfissional,
  definirDataCorteRegistroHora,
  findAllRegistroHoraProfissionalByProfissional,
  inativarRegistroHoraProfissional,
} from "../../../services/RegistroHoraProfissionalService";
import {findAllProfissionalSaudeComAgenda} from "../../../services/ProfissionalSaudeService";
import {Button} from "../../../components/ui/Buttons";
import InputDateForm from "../../../components/Input/InputDateForm";
import InputTimeForm from "../../../components/Input/InputTimeForm";
import moment from "moment";

const styles = {
  container: {
    gridArea: "content",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    overflow: "hidden",
    position: "relative",
    "& thead th": { textAlign: "left", top: 0, position: "sticky" },
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    padding: "24px",
    backgroundColor: "#F5F5F5",
    gap: "16px",
    "& > div": {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      borderRadius: "16px",
      border: "solid 1px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#FFF",
    },
  },
  notFoundContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
  detailContainer: {
    gridArea: "content",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  detailHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
    backgroundColor: "#FFF",
    borderBottom: "1px solid rgba(0,0,0,0.1)",
  },
  detailTitle: {
    fontWeight: 700,
    fontSize: "18px",
  },
  filterRow: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    padding: "16px 24px",
    backgroundColor: "#FFF",
  },
  detailContent: {
    flex: 1,
    overflow: "auto",
    padding: "24px",
    backgroundColor: "#F5F5F5",
  },
  registrosTable: {
    borderRadius: "16px",
    border: "solid 1px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#FFF",
    overflow: "hidden",
  },
  formFields: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    minWidth: "300px",
  },
};

const ProfissionaisHoristas = ({ classes }) => {
  const [profissionais, setProfissionais] = useState([]);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: "", type: "error" });

  // Detail view state
  const [selectedProfissional, setSelectedProfissional] = useState(null);
  const [registros, setRegistros] = useState([]);
  const [mesSelecionado, setMesSelecionado] = useState(moment());

  // Edit modal state
  const [editModal, setEditModal] = useState(false);
  const [editForm, setEditForm] = useState({ id: null, horaInicio: "", horaFim: "" });

  // Data corte modal on main list
  const [dataCorteModal, setDataCorteModal] = useState(false);
  const [dataCorteForm, setDataCorteForm] = useState({ profissional: null, dataCorte: "" });

  const unidade = JSON.parse(localStorage.getItem("_immortal|unidade_logada") || "{}");

  useEffect(() => {
    loadProfissionais();
  }, []);

  useEffect(() => {
    if (selectedProfissional) {
      loadRegistros();
    }
  }, [mesSelecionado, selectedProfissional]);

  const loadProfissionais = async () => {
    try {
      setLoading(true);
      const result = await findAllProfissionalSaudeComAgenda({
        unidadeId: unidade.id,
        ativo: true,
        pageableDTO: { pageSize: 100, pageNumber: 0, sortField: "nome", sortDir: "ASC" },
      });
      setProfissionais(result?.content || []);
    } catch (e) {
      showNotification(e.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const loadRegistros = async (profissional) => {
    const prof = profissional || selectedProfissional;
    if (!prof) return;
    try {
      const dataInicio = moment(mesSelecionado).startOf("month").format("YYYY-MM-DD");
      const dataFim = moment(mesSelecionado).endOf("month").format("YYYY-MM-DD");

      const result = await findAllRegistroHoraProfissionalByProfissional({
        profissionalSaudeId: prof.id,
        dataInicio,
        dataFim,
        pageableDTO: { pageSize: 200, pageNumber: 0, sortField: "data", sortDir: "DESC" },
      });

      setRegistros(result?.content || []);
    } catch (e) {
      setRegistros([]);
      showNotification(e.message, "error");
    }
  };

  const showNotification = (message, type = "error") => {
    setNotification({ open: true, message, type });
    setTimeout(() => setNotification({ open: false, message: "", type: "error" }), 4000);
  };

  const handleClickProfissional = async (id) => {
    const prof = profissionais.find((p) => p.id === id);
    setMesSelecionado(moment());
    setSelectedProfissional(prof);
    await loadRegistros(prof);
  };

  const handleVoltar = () => {
    setSelectedProfissional(null);
    setRegistros([]);
  };

  const handleOpenEdit = (registro) => {
    setEditForm({
      id: registro.id,
      horaInicio: registro.horaInicio ? moment(registro.horaInicio, "HH:mm") : null,
      horaFim: registro.horaFim ? moment(registro.horaFim, "HH:mm") : null,
    });
    setEditModal(true);
  };

  const handleSaveEdit = async () => {
    try {
      await atualizarRegistroHoraProfissional({
        id: editForm.id,
        horaInicio: editForm.horaInicio ? moment(editForm.horaInicio).format("HH:mm") : null,
        horaFim: editForm.horaFim ? moment(editForm.horaFim).format("HH:mm") : null,
      });
      setEditModal(false);
      showNotification("Registro atualizado com sucesso!", "success");
      await loadRegistros();
    } catch (e) {
      showNotification(e.message, "error");
    }
  };

  const handleInativar = async (registroId) => {
    if (!window.confirm("Deseja inativar este registro?")) return;
    try {
      await inativarRegistroHoraProfissional({ id: registroId });
      showNotification("Registro inativado com sucesso!", "success");
      await loadRegistros();
    } catch (e) {
      showNotification(e.message, "error");
    }
  };

  const handleOpenDataCorteModal = (prof, e) => {
    e.stopPropagation();
    setDataCorteForm({ profissional: prof, dataCorte: prof.dataCorte || "" });
    setDataCorteModal(true);
  };

  const handleSaveDataCorte = async () => {
    const valor = parseInt(dataCorteForm.dataCorte);
    if (!valor || valor < 1 || valor > 31) {
      showNotification("Informe um dia válido (1-31).", "error");
      return;
    }
    try {
      await definirDataCorteRegistroHora({
        profissionalSaudeId: dataCorteForm.profissional.id,
        dataCorte: valor,
      });
      showNotification("Data de corte atualizada com sucesso!", "success");
      setDataCorteModal(false);
      await loadProfissionais();
    } catch (e) {
      showNotification(e.message, "error");
    }
  };

  // Detail view columns
  const columnsRegistros = [
    { Header: "Data", getValue: (row) => row.data ? moment(row.data).format("DD/MM/YYYY") : "-" },
    { Header: "Hora Início", getValue: (row) => row.horaInicio || "-" },
    { Header: "Hora Fim", getValue: (row) => row.horaFim || "-" },
    { Header: "Ações", getValue: (row) => (
      <div style={{ display: "flex", gap: 4 }}>
        <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleOpenEdit(row); }} title="Editar">
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleInativar(row.id); }} title="Inativar">
          <DeleteIcon fontSize="small" color="error" />
        </IconButton>
      </div>
    )},
  ];

  // Main list columns
  const columnsProfissionais = [
    { Header: "Nome", getValue: (row) => row.nome },
    { Header: "Data Corte", getValue: (row) => row.dataCorte ? `Dia ${row.dataCorte}` : "—" },
    { Header: "Ações", getValue: (row) => (
      <IconButton
        size="small"
        onClick={(e) => handleOpenDataCorteModal(row, e)}
        title="Editar data de corte"
      >
        <EditIcon fontSize="small" />
      </IconButton>
    )},
  ];

  // Render detail view
  if (selectedProfissional) {
    return (
      <div className={classes.detailContainer}>
        <div className={classes.detailHeader}>
          <span className={classes.detailTitle}>Registros - {selectedProfissional.nome}</span>
          <Button kind="transparent" onClick={handleVoltar}>← Voltar</Button>
        </div>
        <div className={classes.filterRow}>
          <InputDateForm
            label="Mês"
            value={mesSelecionado}
            onChange={(date) => setMesSelecionado(date)}
          />
        </div>
        <div className={classes.detailContent}>
          <div className={classes.registrosTable}>
            <Table
              dados={registros}
              columns={columnsRegistros}
              clickable={false}
            />
            {registros.length === 0 && (
              <div className={classes.notFoundContainer}>
                <MensagemListaVazia />
              </div>
            )}
          </div>
        </div>

        <Dialog open={editModal} onClose={() => setEditModal(false)}>
          <DialogTitle>Editar Registro</DialogTitle>
          <DialogContent>
            <div className={classes.formFields}>
              <InputTimeForm
                label="Hora Início"
                value={editForm.horaInicio}
                onChange={(time) => setEditForm({ ...editForm, horaInicio: time })}
              />
              <InputTimeForm
                label="Hora Fim"
                value={editForm.horaFim}
                onChange={(time) => setEditForm({ ...editForm, horaFim: time })}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button kind="transparent" onClick={() => setEditModal(false)}>Cancelar</Button>
            <Button kind="primary" onClick={handleSaveEdit}>Salvar</Button>
          </DialogActions>
        </Dialog>

        <Notification
          close={() => setNotification({ ...notification, open: false })}
          reset={() => setNotification({ ...notification, open: false })}
          isOpen={notification.open}
          variant={notification.type}
          message={notification.message}
        />
      </div>
    );
  }

  // Render list view
  return (
    <div className={classes.container}>
      <PageTitle title={pageConfiguracoes("Profissionais Horistas")} />
      <HeaderConfiguracoesButtonNovo
        idPrefix="cfg-prh"
        title="Profissionais Horistas"
        hiddenButton={true}
        search={{ handleChange: () => {}, value: "", onKeypress: () => {}, handleClickClear: () => {}, onClickButtonSearch: () => {} }}
      />
      <div className={classes.tableContainer}>
        <div>
          <Table
            dados={profissionais}
            columns={columnsProfissionais}
            clickable={true}
            handleClick={handleClickProfissional}
          />
          {profissionais.length === 0 && !loading && (
            <div className={classes.notFoundContainer}>
              <MensagemListaVazia />
            </div>
          )}
        </div>
      </div>

      <Dialog open={dataCorteModal} onClose={() => setDataCorteModal(false)}>
        <DialogTitle>Editar Data de Corte - {dataCorteForm.profissional?.nome}</DialogTitle>
        <DialogContent>
          <div className={classes.formFields}>
            <TextField
              label="Dia de corte (1-31)"
              type="number"
              value={dataCorteForm.dataCorte}
              onChange={(e) => setDataCorteForm({ ...dataCorteForm, dataCorte: e.target.value })}
              InputLabelProps={{ shrink: true }}
              inputProps={{ min: 1, max: 31 }}
              fullWidth
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button kind="transparent" onClick={() => setDataCorteModal(false)}>Cancelar</Button>
          <Button kind="primary" onClick={handleSaveDataCorte}>Salvar</Button>
        </DialogActions>
      </Dialog>

      <Notification
        close={() => setNotification({ ...notification, open: false })}
        reset={() => setNotification({ ...notification, open: false })}
        isOpen={notification.open}
        variant={notification.type}
        message={notification.message}
      />
    </div>
  );
};

export default withStyles(styles)(ProfissionaisHoristas);
